type PieceQuantitySource = {
    quantity?: number;
    c_pieceQuantity?: number;
};

type PieceAvailabilitySource = {
    c_pieceAts?: number;
    inventory?: {
        ats?: number;
    };
};

export function getDisplayQuantity(item: PieceQuantitySource | null | undefined, fallback = 1): number {
    return item?.c_pieceQuantity ?? item?.quantity ?? fallback;
}

export function getDisplayAts(item: unknown): number | undefined {
    const source = item as PieceAvailabilitySource | null | undefined;
    return source?.c_pieceAts ?? source?.inventory?.ats;
}
